"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../components/modals/InfoModal");
var commonFunctions_1 = require("../../commonFunctions");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var PricingExplainedRenderers_1 = require("../../components/modals/renderers/PricingExplainedRenderers");
var PremiumOutputWidget = exports.PremiumOutputWidget = /** @class */ (function (_super) {
    __extends(PremiumOutputWidget, _super);
    function PremiumOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.resize = function () {
            _this.setState({
                bgHeight: _this.getBgHeight()
            });
        };
        _this.state = {
            bgHeight: 0
        };
        _this.renderQuestions = _this.renderQuestions.bind(_this);
        return _this;
    }
    PremiumOutputWidget.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener('resize', this.resize);
        window.addEventListener('scroll', this.resize);
        this.setState({
            bgHeight: this.getBgHeight() + 100
        });
        if (this.props.interaction.process !== services_1.INTERACTION_PROCESS_NB) {
            this.customerPortalService.getSubscription().subscribe(function (subscription) {
                if (subscription) {
                    _this.setState({ subscription: subscription });
                }
            });
            this.customerPortalService.getPolicies().subscribe(function (policies) {
                if (policies) {
                    _this.setState({ policies: policies });
                }
            });
        }
    };
    PremiumOutputWidget.prototype.render = function () {
        return (React.createElement("div", { className: "premium-output" },
            React.createElement("div", { className: "top-section" },
                React.createElement("div", { className: "premium-info" }, this.renderFirstMonthPrice())),
            React.createElement("div", { className: "bottom-section" },
                this.renderBulletPoints(true),
                this.renderQuestions())));
    };
    PremiumOutputWidget.prototype.renderFirstMonthPrice = function () {
        var showAdditionalPremium = this.getSetting("showAdditionalPremium", false) && this.props.interaction.factors.additionalPremium > 0;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: "price", className: "price text-center font-family-display font-weight-bold" }, (0, commonFunctions_1.getAmountToDisplay)(showAdditionalPremium ? this.props.interaction.factors.additionalPremium : this.props.interaction.factors.premium)),
            React.createElement("p", { className: "text-center font-weight-bold" },
                "For the first month",
                showAdditionalPremium || React.createElement(InfoModal_1.InfoModal, { className: "mb-2 ml-2", title: "Pricing explained" }, (0, PricingExplainedRenderers_1.renderPricingExplained)(this.props.interaction))),
            React.createElement("p", { className: "text-center mb-0" }, "Price could go up or down monthly."),
            showAdditionalPremium ||
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "d-mobile-none" },
                        React.createElement("p", { className: "text-center mb-0" },
                            "Guaranteed you won't pay more than ",
                            React.createElement("b", null, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.neverHigher)),
                            " for the following 3 months based on your current details."),
                        React.createElement("p", { className: "text-center mb-0" }, "All figures include Insurance Premium Tax")),
                    React.createElement("div", { className: "d-desktop-none" },
                        React.createElement("p", { className: "text-center mb-0" }, "Guaranteed you won't pay more than"),
                        React.createElement("p", { className: "text-center mb-0" },
                            React.createElement("span", { className: "font-weight-bold" }, "".concat((0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.neverHigher), "/mo")),
                            " for the following 3 months based on your current details."),
                        React.createElement("p", { className: "text-center mb-0" }, "All figures include Insurance Premium Tax")))));
    };
    PremiumOutputWidget.prototype.renderBulletPoints = function (withSeparator) {
        return (React.createElement("ul", { className: "list-unstyled font-family-display bullet-points ".concat(withSeparator ? "with-separator" : "") },
            React.createElement("li", { className: "media mb-1" },
                React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                React.createElement("div", { className: "media-body" },
                    React.createElement("p", { className: "mb-0" },
                        React.createElement("span", { className: "font-weight-bold" }, "Flexible"),
                        " \u2013 simple monthly payments"))),
            React.createElement("li", { className: "media mb-1" },
                React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                React.createElement("div", { className: "media-body" },
                    React.createElement("p", { className: "mb-0" },
                        React.createElement("span", { className: "font-weight-bold" }, "No cancellation"),
                        " or admin fees"))),
            React.createElement("li", { className: "media mb-1" },
                React.createElement("img", { className: "mt-1 mr-2", src: "/img/tick.svg", alt: "tick icon" }),
                React.createElement("div", { className: "media-body" },
                    React.createElement("p", { className: "mb-0" },
                        React.createElement("span", { className: "font-weight-bold" }, "Guaranteed maximum price"),
                        " every three months")))));
    };
    PremiumOutputWidget.prototype.renderQuestions = function () {
        return React.createElement(plugin_journey_1.QuestionList, __assign({}, this.props, { questions: this.props.question.questions }));
    };
    PremiumOutputWidget.prototype.getBgHeight = function () {
        var background = document.getElementsByClassName("bg")[0];
        if (!background) {
            return 0;
        }
        return background.getBoundingClientRect().bottom;
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], PremiumOutputWidget.prototype, "customerPortalService", void 0);
    return PremiumOutputWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=PremiumOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/PremiumOutputWidget.js
// module id = 185
// module chunks = 0